// ─── Umlaut-Render-Layer ─────────────────────────────────────────────────
// Regel: "ue" wird zu "ü", AUSSER ein Vokal oder q/Q steht davor.
// Damit sind qu+e-Sequenzen ("Quelle", "Frequenz", "konsequent", "Tu-quoque")
// strukturell ausgeschlossen — keine Wortliste noetig.
// KEEP-Liste nur fuer den Rest (z+ue: "zuerst", "zueinander"; T/tr+ue: "True").
export const GERMANIZE_KEEP = [
  "True", "true",
  "zuerst", "Zuerst", "zueinander",
  "Foerster", "Foersters"
];
export const GERMANIZE_SKIP_KEYS = new Set(["id", "target"]);

export function germanize(text) {
  if (typeof text !== "string") return text;
  const markers = {};
  let t = text;
  GERMANIZE_KEEP.forEach((w, i) => {
    const ph = "\x00" + i + "\x00";
    markers[ph] = w;
    t = t.split(w).join(ph);
  });
  t = t
    .replace(/Ae/g, "Ä").replace(/Oe/g, "Ö").replace(/(?<![aeiouäöüAEIOUÄÖÜqQ])Ue/g, "Ü")
    .replace(/ae/g, "ä").replace(/oe/g, "ö").replace(/(?<![aeiouäöüAEIOUÄÖÜqQ])ue/g, "ü")
    .replace(/ -- /g, " – ");
  Object.entries(markers).forEach(([ph, w]) => { t = t.split(ph).join(w); });
  return t;
}

export function applyGermanize(val, skip) {
  if (skip) return val;
  if (typeof val === "string") return germanize(val);
  if (Array.isArray(val)) return val.map(v => applyGermanize(v));
  if (val !== null && typeof val === "object") {
    const out = {};
    for (const k of Object.keys(val)) out[k] = applyGermanize(val[k], GERMANIZE_SKIP_KEYS.has(k));
    return out;
  }
  return val;
}
